module.exports = __webpack_public_path__ + "img/lights-on-comunicacao.aba6e812.webp";